import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../components/ui/select";
import type { ZipOrganizationPattern } from "../../../../../models/audit/evidenceUpload";

interface MatchingModeSelectProps {
  value: ZipOrganizationPattern;
  onChange: (value: ZipOrganizationPattern) => void;
  disabled?: boolean;
}

// Only two of the four patterns are choices a user can act on, because only
// two behave differently: map folders to samples, or let AI match every file.
// `flat` and `unknown` hit the same backend branch and `doc_type_based` has no
// UI to map with, so everything but `sample_based` normalises to `unknown`.
const patternLabels: Record<ZipOrganizationPattern, string> = {
  sample_based: "Match folders to samples",
  doc_type_based: "Ignore folders - AI matches every file",
  flat: "Ignore folders - AI matches every file",
  unknown: "Ignore folders - AI matches every file",
};

export function MatchingModeSelect({
  value,
  onChange,
  disabled,
}: MatchingModeSelectProps) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-medium text-stone-700">Matching mode:</span>
      <Select
        value={value}
        onValueChange={(v) => onChange(v as ZipOrganizationPattern)}
        disabled={disabled}
      >
        <SelectTrigger className="w-64">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="sample_based">
            {patternLabels.sample_based}
          </SelectItem>
          <SelectItem value="unknown">{patternLabels.unknown}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
